import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
} from 'reactstrap';

import Grid from '../../../components/cms/grid';
import AddNewButton from '../../../components/cms/grid/addNewButton';
import ModelService from '../../../services/slide.service';

const initCriteria = {
  id: '',
  name: '',
  position: '',
  description: '',
  priority: '',
  status: '',
  order: 'asc',
  sortBy: 'priority',
};

const Slides = ({ t, getColumns }) => (
  <div className="">
    <Row>
      <Col xl={12}>
        <Card>
          <CardHeader>
            <strong><i className="fa fa-edit" /> {t('Slides')}</strong>
          </CardHeader>
          <CardBody>
            <div className="pull-right mb-1">
              <AddNewButton
                to={ModelService.getCreateUrl()}
                permissionToCreate={ModelService.getCreatePermissions()}
              />
            </div>
            <Grid id="slides" service={ModelService} columns={getColumns(t)} initCriteria={initCriteria} />
          </CardBody>
        </Card>
      </Col>
    </Row>
  </div>
);

Slides.propTypes = {
  t: PropTypes.func.isRequired,
  getColumns: PropTypes.func.isRequired,
};

export default Slides;



// WEBPACK FOOTER //
// ./src/views/content/slides/Slides.jsx